
export const Urls = {
    GetVesselDetails: "VesselComparison/GetVesselDetails",
    CreateVesselComparisonPdf: "VesselComparison/CreateVesselComparisonPdf"
}